import { ClusterDetails } from 'components/clusters/cluster-details';

const ClusterDetailsPage = () => {
  return <ClusterDetails />;
};

export default ClusterDetailsPage;
